import {
  InfoCircleOutlined,
  WarningOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons-vue";

export enum AttachmentStatus {
  NORMAL = "normal",
  WARNING = "warning",
  DANGER = "danger",
  LIMIT = "limit",
}

export const ATTACHMENT_THRESHOLDS = {
  WARNING: 80,
  DANGER: 96,
  LIMIT: 100,
};

export const ATTACHMENT_STATUS_CONFIG = {
  [AttachmentStatus.NORMAL]: {
    textColor: "#8c8c8c",
    barColor: "#1677FF",
    icon: InfoCircleOutlined,
    title: "Aún no llega al límite permitido (hasta el 79%)",
  },

  [AttachmentStatus.WARNING]: {
    textColor: "#D48806",
    barColor: "#FAAD14",
    icon: WarningOutlined,
    title: "Aún no llega al límite permitido (desde 80% hasta el 95%)",
  },

  [AttachmentStatus.DANGER]: {
    textColor: "#CF1322",
    barColor: "#FFA39E",
    icon: WarningOutlined,
    title: "Aún no llega al límite permitido (desde 96% hasta el 99%)",
  },

  [AttachmentStatus.LIMIT]: {
    textColor: "#CF1322",
    barColor: "#FF4D4F",
    icon: CloseCircleOutlined,
    title: "Completó los 10MB",
  },
};